export default __webpack_public_path__ + "static/media/event-faq.b5757478.jpg";